import { useState, useEffect, useRef } from "react";
import "../styles/transaction.css";
import Pencil from "../images/icons/Pencil.svg";
import Trash from "../images/icons/Trash.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { faqDelete } from "../actions/adminAction";
import { Modal, Button } from "react-bootstrap";
import danger from "../images/danger.svg";

const FaqTable = ({ data, currentPage }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [expandedRows, setExpandedRows] = useState({}); // State to manage expanded rows
 const [show, setShow] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

 const handleClose = () => setShow(false);
  const handleShow = (faqId) => {
    setDeleteId(faqId); // Set the ticket ID when opening modal
    setShow(true);
  };

  const handleDeleteClick = () => {
      dispatch(faqDelete(deleteId)).then((res) => {
        setShow(false)
      }); // Dispatch action to delete FAQ
  };

  const handleEditClick = (faqId) => {
    navigate("/admin/editfaq", { state: faqId }); // Redirect to the Edit FAQ page
  };

  const toggleExpandRow = (index) => {
    setExpandedRows((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <div className="table-container table-responsive">
      <table className="table_transaction">
        <thead>
          <tr>
            <th>Sr. No.</th>
            <th>Question</th>
            <th>Answer</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? (
            data.map((faqs, index) => (
              <tr
                key={index}
                className={`${
                  faqs?.faqs?.trxn_status?.toLowerCase() ||
                  faqs?.status?.toLowerCase()
                } transaction_row`}
              >
                <td>{(currentPage - 1) * 10 + index + 1}</td>
                <td className="white-space-normal">{faqs?.question}</td>
                <td className="white-space-normal">
                  {expandedRows[index]
                    ? faqs.answer
                    : faqs.answer.slice(0, 50) +
                      (faqs.answer.length > 50 ? "..." : "")}
                  {faqs.answer.length > 50 && (
                    <button
                      className="see-more-less"
                      onClick={() => toggleExpandRow(index)}
                    >
                      {expandedRows[index] ? "See Less" : "See More"}
                    </button>
                  )}
                </td>
                <td>
                  {" "}
                  <div className="d-flex gap-2">
                    <div
                      className="goals-edit"
                      style={{ cursor: "pointer" }}
                      data-bs-toggle="tooltip"
                      data-bs-placement="bottom"
                      title="Edit"
                    >
                      <img
                        src={Pencil}
                        alt="Edit Icon"
                        data-bs-toggle="tooltip"
                        data-bs-placement="bottom"
                        title="Edit"
                        style={{ cursor: "pointer" }} // Add pointer cursor to indicate interactivity
                        onClick={() => handleEditClick(faqs?.id)}
                      />
                    </div>
                    <div
                      className="goals-delete"
                      style={{ cursor: "pointer" }}
                      data-bs-toggle="tooltip"
                      data-bs-placement="bottom"
                      title="Delete"
                      onClick={() => handleShow(faqs?.id)}
                      >
                      <img
                        src={Trash}
                        alt=""
                        data-bs-toggle="tooltip"
                        data-bs-placement="bottom"
                        title="Delete"
                      />
                    </div>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr style={{ height: "100px" }}>
              <td colSpan="12" className="no-data-message text-center">
                No FAQ found
              </td>
            </tr>
          )}
        </tbody>
      </table>

        <Modal
              show={show}
              onHide={handleClose}
              centered
              dialogClassName="custom-modal justify-content-center"
            >
              <div className=" position-relative">
                <button
                  type="button"
                  className="btn-close position-absolute top-0 end-0"
                  onClick={handleClose}
                  aria-label="Close"
                  style={{
                    fontSize: "1.1rem",
                    cursor: "pointer",
                    opacity: 0.8, // Ensure full visibility
                  }}
                ></button>
              </div>
              <div className="modal-title mt-4">
                <img src={danger} alt="Danger Icon" className="modal-icon" />
                <h4 className="modal-text">
                  Are you sure you want to delete FAQ?
                </h4>
              </div>
              <div className="d-flex justify-content-spacearound mt-4">
                <button onClick={handleClose} className="form_button ">
                  Cancel
                </button>
                <button
                  type="button"
                  className="form_button next_btn"
                  onClick={handleDeleteClick} // Call function to close ticket
                >
                  OK
                </button>
              </div>
            </Modal>
    </div>
  );
};

export default FaqTable;
